<servicing-facility-general-info
  class="mb-4"
  [servicingFacility]="servicingFacility"
  [tenantName]="tenantName"
  [isGoldCardVisible]="isGoldCardVisible"
></servicing-facility-general-info>

<servicing-facility-contact-info
  class="mb-4"
  [providerAccount]="servicingFacility"
></servicing-facility-contact-info>

<servicing-facility-contact-details
  [contactDetails]="contactDetails"
  [isExternal]="isExternalFlow"
  (detailsUpdated)="setContactDetails($event)"
></servicing-facility-contact-details>
